<template>
    <div class="" style="padding-top: 5rem;">
        
        <div class="section " id="call-to-action" style="">
            <div class="row d-flex p-5">
                <div class="col-12 col-lg-6 my-5 mb-lg-0 text-center">
                    <img src="/images/main_page_01.png" class="call-to-action__image" alt="">
                </div>
                <div class="col-12 col-lg-6 d-flex justify-content-center align-items-center p-4 mb-5">
                    <div>
                        <h2>Ваш путь к успеху</h2>
                        <p class="my-4">Развивайте навыки с помощью онлайн-курсов! Наши курсы - самые лучшие! Покупайте наших слонов!</p>
                        <p style="color: red">!!текст и слоган надо заменить!!</p>
                        <!-- <button class="btn btn-primary">I'm a button! Press me!</button> -->
                        <router-link class="btn btn__primary" :to="{ name: 'register' }">Присоединиться</router-link>
                    </div>      
                </div>
            </div>
        </div>


        <!-- Наши преимущества -->
        <div class="section " style="padding: 5rem 0 3rem;">
            <div class="row justify-content-between p-3 ">
                <!-- <div v-for="plus in pluses" v-bind:key="plus.id" class="col-md-3 col-12 text-center p-3 mb-3"> -->
                <div v-for="plus in pluses" v-bind:key="plus.id" class="col-12 col-md-6 col-lg-3  text-center p-5 mb-1 ">
                    <img :src="plus.image" class="w-25 mb-3" alt="">
                    <h3 class="mb-2">{{plus.caption}}</h3>
                    <p>{{plus.text}}</p>
                </div>
            </div>
        </div>

        <!-- Отзывы -->
        <div class="section p-5 mt-1 ">
            <h3 class="text-center mt-3 mb-5">Более 10000 человек уже окончили наши курсы</h3>
            <div id="testimonials-slider" class="mt-5">
                <div v-for="tm in testimonials" v-bind:key="tm.id" class="p-3 text-center">
                    <img :src="tm.image" class="d-block testimonials-slider__image mx-auto mb-3" alt="">
                    <h5>{{tm.name}}</h5>
                    <p style="font-weight: bold">{{tm.profession}}</p>
                    <p style="font-style: italic;">{{tm.text}}</p>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import jQuery from 'jquery'
import 'lightslider'
export default {
    data() {
        return {
            // наши преимущества:
            pluses: [
                { id: 1, image: '/images/c3-1.svg', caption: 'Проходите курсы',     text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, eaque ipsam!' },
                { id: 2, image: '/images/c3-2.svg', caption: 'Развивайте навыки',   text: 'Vitae saepe nostrum facere quo commodi reiciendis nemo nam.' },
                { id: 3, image: '/images/c3-3.svg', caption: 'Работайте над собой', text: 'Iste, eaque ipsam! Harum, quibusdam earum animi reiciendis voluptatibus nesciunt ipsum recusandae voluptatem?' },
                { id: 4, image: '/images/c3-4.svg', caption: 'Ура!',                text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            ],
            // отзывы:
            /*
            testimonials: [
                { id: 1, name: 'Maria Montes',     profession: 'Web-developer',    image: '/images/woman.svg',     text: '"Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit et mollitia ea, labore repellat nobis aliquam at velit dolorum porro consectetur quo eum aperiam eligendi similique dignissimos dolore fuga saepe!"' },
                { id: 2, name: 'Huge Gonsales',    profession: 'Data Scientist',   image: '/images/woman2.svg',    text: '"Sit et mollitia ea, labore repellat nobis aliquam at velit dolorum porro consectetur quo eum aperiam!"' },
                { id: 3, name: 'Tom Goodman',      profession: 'QA Engineer',      image: '/images/buddha.svg',    text: '"Sit et mollitia ea, labore repellat nobis aliquam at velit dolorum porro consectetur quo eum aperiam eligendi similique dignissimos dolore fuga saepe!"' },
                { id: 4, name: 'Jessica Brown',    profession: 'Web-developer',    image: '/images/lotus.svg',     text: '"Lorem ipsum dolor sit amet consectetur adipisicing elit."' },
            ],
            */
            testimonials: [
                { id: 1, name: 'Владимир Артемьев',     profession: 'Веб-разработчик',    image: '/images/person3.jpg',     text: 'Курсы научили меня подхватывать идеи на лету и применять их на практике.' },
                { id: 2, name: 'Елена Буравина',    profession: 'Инженер',   image: '/images/person4.jpg',    text: 'Очень полезные и интересные курсы! Мне понравилось, что много практических навыков смогла подчеркнуть для себя!' },
                { id: 3, name: 'Татьяна Соколова',      profession: 'Ведущий специалист',      image: '/images/person5.jpg',    text: 'Спасибо! Без нового уровня я бы не смогла работать - это не комплимент, это факт. Спасибо за то, что Вы делаете.' },
                { id: 4, name: 'Роман Быков',    profession: 'Администратор',    image: '/images/person6.jpg',     text: 'Ваши знания и опыт бесценен! Вы задаете очень высокие стандарты, на вас хочется ровняться!' },
            ],
        }
    },
    mounted() {
        jQuery('#testimonials-slider').lightSlider({
            item: 4,
            autoWidth: false,
            slideMove: 1, // slidemove will be 1 if loop is true
            slideMargin: 30,
            loop: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        item: 3,
                        slideMargin: 20
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        item: 2,
                        slideMargin: 10,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        item: 1,
                    }
                }
            ]
        });
    },
    
}
</script>

<style scoped>



/* 
    Home_unregistered
*/

#call-to-action {
    background-image: linear-gradient(to bottom, #f3f3f3, #fff);
    /* clip-path       : polygon(0% 0%, 100% 0%, 100% 100%,0% 100%); */
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);

}

.call-to-action__image {
    width        : 300px;
    height       : 300px;
    object-fit   : cover;
    border-radius: 50%;
}

.box-shadow {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);
}


/*
    For testimonial slider
*/
#testimonial-slider {

}

.testimonials-slider__image {
    width        : 100px;
    height       : 100px;
    object-fit   : cover;
    border-radius: 50%;
}


</style>
